import Typography from '../Typography';
import styled from 'styled-components';

export type ListProps = {
  elements: string[];
  type: 'ul' | 'ol';
};

const UlContainer = styled.ul`
  display: flex;
  flex-direction: column;
`;

const OlContainer = styled.ol`
  display: flex;
  flex-direction: column;
`;

const ListElement = styled.li`
  display: flex;
  align-items: center;
`;

const Dot = styled.span`
  height: 0.375rem;
  width: 0.375rem;
  background-color: black;
  border-radius: 50%;
  display: inline-block;
  margin-right: 0.625rem;
`;

const List = (props: ListProps): JSX.Element | null => {
  const { elements, type } = props;
  switch (type) {
    case 'ul':
      return (
        <UlContainer>
          {elements.map((list, i) => (
            <ListElement key={`${list}${i + 1}`}>
              <Dot />
              <Typography type="body1">{list}</Typography>
            </ListElement>
          ))}
        </UlContainer>
      );
    case 'ol':
      return (
        <OlContainer>
          {elements.map((list, i) => (
            <ListElement key={`${list}${i + 1}`}>
              <Typography type="body1">{`${i + 1}.    ${list}`}</Typography>
            </ListElement>
          ))}
        </OlContainer>
      );
    default:
      return <List type="ul" elements={['element']} />;
  }
};

export default List;
